module.exports = __webpack_public_path__ + "img/snowman-head.2d242e21.svg";